import React, { FC, useCallback, useEffect } from 'react'

import type { Props } from '../CommonTemplate/CommonTemplate'
import { CommonTemplate } from '../CommonTemplate/CommonTemplate'
import { WixStudioLogoWithBack } from '../WixStudioLogoWithBack'
import { wixStudioTemplateDataHooks as dataHooks } from './WixStudioTemplate.dataHooks'
import { WixStudioTemplateSidePanel } from './WixStudioTemplateSidePanel'

export const WixStudioTemplate: FC<Props> = props => {
  const { isPageLoading, pageLogger, backButton, onSkipClick } = props

  const handleBackClick = useCallback(() => {
    if (isPageLoading) {
      return
    }
    void pageLogger.back()

    window.history.back()
  }, [isPageLoading, pageLogger])

  const handleSkipClick = useCallback(() => {
    if (isPageLoading) {
      return
    }
    void pageLogger.skip()

    onSkipClick?.()
  }, [isPageLoading, pageLogger, onSkipClick])

  useEffect(() => {
    void pageLogger.screenView()
  }, [pageLogger])

  return (
    <CommonTemplate
      sidePanel={<WixStudioTemplateSidePanel />}
      {...props}
      logo={
        props.logo || (
          <WixStudioLogoWithBack dataHook={dataHooks.back()} backButton={backButton} onBackClick={handleBackClick} />
        )
      }
      onSkipClick={handleSkipClick}
      dataHook={dataHooks.baseTemplate()}
    />
  )
}
